/* eslint-disable import/prefer-default-export */
export const getRandomNumber = (max) => {
    // Return a random number between 1 and max.
    return Math.floor(Math.random() * Math.floor(max)) + 1;
};
